import RegularButton from '@/components/buttons/RegularButton'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import YouTubeIcon from '@mui/icons-material/YouTube'
import Grid from '@mui/material/Grid2'
import IconButton from '@mui/material/IconButton'
import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import galleryData from './galleryVideos.json'
import YoutubePlayer from './YoutubePlayer'

const ImageGallery: React.FC = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const selector = searchParams.get('selector')
  const foundImageKey = Object.keys(galleryData).find(
    (dataKey) => dataKey === selector,
  )
  const dataSet = foundImageKey
    ? galleryData[foundImageKey as keyof typeof galleryData]
    : undefined
  return (
    <>
      <Grid
        container
        direction="row"
        columnSpacing={2}
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid size={10} textAlign="start" marginTop="20px">
          <RegularButton
            label={
              <>
                <ArrowBackIcon /> Tillbaka
              </>
            }
            onClick={() => navigate('/gallery-selector')}
          />
        </Grid>

        {!foundImageKey ? (
          <Grid size={10}>
            <h1>Inga filmer här :(</h1>
          </Grid>
        ) : (
          <>
            <Grid size={10}>
              <h1>{dataSet?.header}</h1>
              <h2>
                Vi finns också på Youtube
                <IconButton
                  sx={{ color: '#000000' }}
                  onClick={() =>
                    window.open(
                      'https://www.youtube.com/@KarlshamnsScoutmusikk%C3%A5r',
                    )
                  }
                >
                  <YouTubeIcon />
                </IconButton>
              </h2>
            </Grid>
            {dataSet?.videos.map((video, index) => (
              <Grid
                key={index}
                container
                direction="row"
                size={{ xs: 11, md: 12 }}
                spacing={2}
                justifyContent="center"
                alignItems="center"
                textAlign="center"
                marginBottom="20px"
              >
                <Grid size={{ xs: 12, md: 5 }}>
                  <h3>{video.header}</h3>
                  <p style={{ textAlign: 'start' }}>{video.description}</p>
                  <p style={{ textAlign: 'start' }}>
                    <i>{video.source}</i>
                  </p>
                </Grid>

                <Grid container direction="column" size={{ xs: 12, md: 5 }}>
                  <YoutubePlayer id={video.youtubeId} />
                </Grid>
              </Grid>
            ))}
          </>
        )}
      </Grid>
    </>
  )
}

export default ImageGallery
